<template>
  <div
    class="border-b-0 box-border relative grow shrink basis-0 px-3 py-2 bg-white border-s border-t border-gray-300 flex-col justify-start items-start inline-flex"
    style="border-right: 1px solid #d1d5db"
  >
    <div class="flex items-center justify-between w-full">
      <span class="text-gray-500 text-xs font-normal leading-3">
        Customer Tags
      </span>
      <div v-if="tags" class="flex items-center gap-1">
        <i
          v-if="tags.length < maxTags"
          class="fa-light fa-plus tag-menu-btn text-xs cursor-pointer"
          aria-label="Add Tag"
          @click="toggleTagMenu"
        ></i>
        <TagMenu
          v-if="showTagMenu"
          :taggable-type="'customer'"
          :tag-count="tags?.length ?? 0"
          @close-menu="toggleTagMenu"
          @add-tag="handleAddTag"
          @open-tag-modal="toggleNewTagModal"
        />
      </div>
    </div>
    <div>
      <div class="flex flex-wrap items-center gap-1.5 w-full">
        <div
          class="flex flex-row gap-3 text-gray-900 text-sm font-normal whitespace-nowrap overflow-visible block"
        >
          <template v-if="tags.length === 0">
            <div>
              <span>No Tags</span>
            </div>
          </template>
          <template v-else>
            <div class="flex flex-wrap items-center gap-2 pt-2">
              <TagList
                :tags="tags ?? []"
                :config="tagListConfig"
                @remove-tag="handleRemoveTag"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <TagModal
      v-if="showTagModal"
      :tag="newTag"
      @hide-modal="toggleNewTagModal"
      @save-new-success="handleSaveSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, watch } from "vue";

import TagList from "@/Tags/TagList.vue";
import TagMenu from "@/Tags/TagMenu.vue";
import TagModal from "@/Tags/TagModal.vue";
import { Customer } from "@/typings/customer";
import { useAppointmentTags } from "./useAppointmentTags";

const emit = defineEmits(["tags-change"]);
const props = defineProps({
  customer: {
    type: Customer,
    required: true
  }
});

const {
  newTag,
  tags,
  showTagMenu,
  showTagModal,
  tagListConfig,
  maxTags,
  toggleTagMenu,
  toggleNewTagModal,
  handleAddTag,
  handleRemoveTag,
  handleSaveSuccess
} = useAppointmentTags({
  taggableType: "customer",
  entityId: props.customer.customer_id,
  initialTags: props.customer.tags
});

watch(tags, (newVal, oldVal) => {
  if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
    emit("tags-change", newVal);
  }
});
</script>

<style lang="scss" scoped>
.tag-menu-btn {
  background-color: var(--sera-color-neutral-gray-light-gray-300);
  font-size: 15px;
  padding: 4px;
  display: flex;
  border: 0px;
  border-radius: 4px;
  justify-content: end;
}
</style>
